import { useEffect } from "react"

const { Box, TextField, Button, Typography, CircularProgress } = require("@mui/material")
const { useState } = require("react")

/**
 * 
 * @param {object} props E.g. {
 * {string} defaultValue - initial search text
 * {function} findDocs - called with invoiceNumber after user enters text and presses search button
 * {boolean} pageLoading - are we loading invoice data from the server?
 * {object} sx - mui styles
 * }
 * 
 * @returns JSX
 */
export default function AssetDocsSearchByNumber({defaultValue, findDocs, pageLoading, sx}) {
    const [assetNumber, setAssetNumber] = useState(defaultValue || '') // Asset doc number typed by user into search field.
    const [assetNumberError, setAssetNumberError] = useState()
    const [assetNumberHelperText, setAssetNumberHelperText] = useState('')

    useEffect(() => {
        console.log('AssetDocsSearchByNumber useEffect defaultValue', defaultValue)
        if (defaultValue) {
            setAssetNumber(defaultValue)
        }
    }, [defaultValue])

    useEffect(() => {
        const assetNumberOK = isAssetNumber(assetNumber)
        setAssetNumberError(!assetNumberOK)
        setAssetNumberHelperText(assetNumberOK ? '' : 'POLE then at least three digits please, e.g. POLE1084471')
    }, [assetNumber])

    const handleAssetNumberChange = (e) => {
        const theAssetValue = e.target.value ? e.target.value.toUpperCase() : ''
        console.log('AssetDocsSearchByNumber handleAssetNumberChange e.target.value', theAssetValue)
        setAssetNumber(theAssetValue)
    }

    const isAssetNumber = (theAssetNumber) => {
        return theAssetNumber?.match(/^POLE\d\d\d+/i)
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        findDocs(assetNumber)
    }

    return (
        <Box sx={sx}>
            <form onSubmit={handleSubmit}>
                <Typography variant="body1" sx={{mb: 2}}>Search Asset Documents by reference.</Typography>
                <Box sx={{mb: 2}}>
                    <TextField
                        label="Asset Number"
                        placeholder="E.g. POLE1084471"
                        value={assetNumber}
                        onChange={handleAssetNumberChange}
                        error={assetNumberError}
                        helperText={assetNumberHelperText}
                    />
                </Box>
                <Box>
                    <Button type="submit" disabled={assetNumberError || pageLoading} sx={{mr:2}} variant="contained">Find Asset Documents</Button>
                    { pageLoading && <CircularProgress color="secondary" size="1.0em" /> }
                </Box>
            </form>
        </Box>
    )
}
